/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import VendorAccountDeleteMutation from './__mutation__/index.vendorAccount.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationVendorAccountDelete, MutationVendorAccountDeleteResponse] = useMutation(VendorAccountDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationVendorAccountDeleteResponse.loading} onConfirm={() => MutationVendorAccountDelete({ 'variables': { 'vendorAccountId': passOn?.vendorAccountId } }).then(i => {
      // Style Guide.
      toast(i?.data?.VendorAccountDelete?.message)

      // Report success.
      return onClose?.()
    }).catch(i =>
      // Style Guide.
      toast('Something went wrong please try after some time.'))} isLoading={MutationVendorAccountDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
